import { defaultFetch } from './baseApi';

export type EmployeeCategoryType = {
	code: string;
	name: string;
	description: string;
};

export const getEmployeeCategories = () => {
	return defaultFetch<EmployeeCategoryType[]>('/oeemployeecategories');
};
